module.exports = __webpack_public_path__ + "img/低功耗摄像机.a6eedd0c.jpg";